<template>
  <div id="countries">
    <div class="title">
      <h2>Choose your country</h2>
      <div class="line"></div>
    </div>

    <div class="country-list">
      <Country
        v-for="country in countries"
        :key="country.id"
        :country="country"
      />
    </div>
  </div>
</template>

<script>
import Country from './Country';

export default {
  name: 'Countries',
  components: {
    Country,
  },
  data() {
    return {
      countries: [
        {
          name: 'France',
          language: 'Français',
          href: 'https://yoopies.fr/',
          hreflang: 'fr-fr',
          image: 'france.png',
        },
        {
          name: 'United Kingdom',
          language: 'English',
          href: 'https://yoopies.co.uk/',
          hreflang: 'en-gb',
          image: 'england.png',
        },
        {
          name: 'Schweiz',
          language: 'Deutsch',
          href: 'https://de.yoopies.ch/',
          hreflang: 'de-ch',
          image: 'switzerland.png',
        },
        {
          name: 'Suisse',
          language: 'Français',
          href: 'https://yoopies.ch/',
          hreflang: 'fr-ch',
          image: 'switzerland.png',
        },
        {
          name: 'Svizzera',
          language: 'Italiano',
          href: 'https://it.yoopies.ch/',
          hreflang: 'it-ch',
          image: 'switzerland.png',
        },
        {
          name: 'Belgique',
          language: 'Français',
          href: 'https://yoopies.be/',
          hreflang: 'fr-be',
          image: 'belgium.png',
        },
        {
          name: 'België',
          language: 'Nederlands',
          href: 'https://nl.yoopies.be/',
          hreflang: 'nl-be',
          image: 'belgium.png',
        },
        {
          name: 'Italia',
          language: 'Italiano',
          href: 'https://yoopies.it/',
          hreflang: 'it-it',
          image: 'italy.png',
        },
        {
          name: 'Deutschland',
          language: 'Deutsch',
          href: 'https://yoopies.de/',
          hreflang: 'de-de',
          image: 'germany.png',
        },
        {
          name: 'Österreich',
          language: 'Deutsch',
          href: 'https://yoopies.at/',
          hreflang: 'de-at',
          image: 'austria.png',
        },
        {
          name: 'España',
          language: 'Español',
          href: 'https://yoopies.es/',
          hreflang: 'es-es',
          image: 'spain.png',
        },
        {
          name: 'Portugal',
          language: 'Português',
          href: 'https://yoopies.pt/',
          hreflang: 'pt-pt',
          image: 'portugal.png',
        },
        {
          name: 'Suomi',
          language: 'Suomi',
          href: 'https://yoopies.fi/',
          hreflang: 'fi-fi',
          image: 'finland.png',
        },
        {
          name: 'Luxembourg',
          language: 'Français',
          href: 'https://yoopies.lu/',
          hreflang: 'fr-lu',
          image: 'luxembourg.png',
        },
        {
          name: 'Luxemburg',
          language: 'Deutsch',
          href: 'https://de.yoopies.lu/',
          hreflang: 'de-lu',
          image: 'luxembourg.png',
        },
        {
          name: 'Sverige',
          language: 'Svenska',
          href: 'https://yoopies.se/',
          hreflang: 'sv-se',
          image: 'sweden.png',
        },
        {
          name: 'Nederland',
          language: 'Nederlands',
          href: 'https://yoopies.nl/',
          hreflang: 'nl-nl',
          image: 'netherlands.png',
        },
        {
          name: 'Danmark',
          language: 'Dansk',
          href: 'https://yoopies.dk/',
          hreflang: 'da-dk',
          image: 'danmark.png',
        },
        {
          name: 'Hong Kong',
          language: 'English',
          href: 'https://helperchoice.com/',
          hreflang: 'en-hk',
          image: 'hong-kong.png',
        },
        {
          name: 'Singapore',
          language: 'English',
          href: 'https://helperchoice.com/',
          hreflang: 'en-sg',
          image: 'singapore.png',
        },
        {
          name: 'Polska',
          language: 'Polski',
          href: 'https://yoopies.pl/',
          hreflang: 'pl-pl',
          image: 'poland.png',
        },
        {
          name: 'Lithuania',
          language: 'Lietuvių',
          href: 'https://yoopies.lt/',
          hreflang: 'lt-lt',
          image: 'lithuania.png',
        },
        {
          name: 'Norge',
          language: 'Norsk',
          href: 'https://yoopies.no/',
          hreflang: 'no-no',
          image: 'norway.png',
        },
      ],
    };
  },
  mounted() {
    this.addSeoLinks();
  },
  methods: {
    addSeoLinks() {
      this.countries.forEach((country) => {
        const link = document.createElement('link');
        link.rel = 'alternate';
        link.href = country.href;
        link.hreflang = country.hreflang;

        document.head.appendChild(link);
      });

      const link = document.createElement('link');
      link.rel = 'alternate';
      link.href = 'https://yoopies.com';
      link.hreflang = 'x-default';

      document.head.appendChild(link);
    },
  },
};
</script>

<style lang="scss" scoped>
#countries {
  background-color: #f7f7f7;
  text-align: center;
  width: 100%;
  min-width: 300px;
  padding-top: 50px;
  padding-bottom: 50px;
  position: relative;

  @media screen and (min-width: 720px){
    padding-top: 84px;
    padding-bottom: 64px;
  }
}

.title {
  h2 {
    font-size: 24px;
    font-family: 'Montserrat-Medium';
    color: #144862;
    margin-bottom: 0;
    margin-top: 0;
    font-weight: 900;

    @media screen and (min-width: 720px){
      font-size: 44px;
    }
  }
}

.line{
  width: 260px;
  height: 5px;
  border-radius: 6.5px;
  margin-top: -8px;
  background-color: #32bfa3;
  margin-left: auto;
  margin-right: auto;

  @media screen and (min-width: 720px){
    width: 480px;
    height: 8px;
    margin-top: -15px;
  }
}

.country-list{
  margin-top: 50px;
  margin-left: 0;
  margin-right: auto;
  text-align: left;
  display: flex;
  flex-direction: column;

  @media screen and (min-width: 720px){
    margin-top: 100px;
    margin-left: 80px;
    margin-right: 80px;
    flex-direction: unset;
    display: block;
    text-align: center;
  }

  @media screen and (min-width: 1230px){
    margin-left: 250px;
    margin-right: 250px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Countries.vue